import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { vaultKeys } from "../queryKeys";
import { vaultApi } from "../../../api/vault.api";
import type { Folder } from "../../../redux/interfaces/folder.types";

interface UseVaultFolderOptions {
  readonly getRefetchInterval?: (folder: Folder | undefined) => number | false;
}

export function useVaultFolder(
  id: string | undefined,
  jwtToken: string | null,
  options?: UseVaultFolderOptions,
) {
  const authScope = jwtToken ?? "anonymous";

  return useQuery({
    queryKey: vaultKeys.folder(id ?? "", authScope),
    queryFn: () => vaultApi.getFolderById(id!),
    enabled: Boolean(id && jwtToken),
    staleTime: 2 * 60_000,
    refetchInterval: (query) =>
      options?.getRefetchInterval?.(query.state.data) ?? false,
  });
}

export function useInvalidateVaultFolder(folderId: string | undefined) {
  const queryClient = useQueryClient();
  return useCallback(
    (options?: { throwOnError?: boolean }) =>
      queryClient.invalidateQueries(
        {
          queryKey: vaultKeys.folder(folderId ?? ""),
        },
        {
          throwOnError: options?.throwOnError ?? false,
        },
      ),
    [queryClient, folderId],
  );
}
